import { date, format, getValueFromJson } from "../../utils/index";
import I18n from "../../I18n";
import { datetime, stringifyFilter } from "colbi_web_ui/lib/utils";
import { snakeCaseToPascalCase } from "../../utils";
import { Buffer } from "buffer";
let hideCheckBox;

const extractEntityName = (entityId) => {
    const parsedEntityId = JSON.parse(entityId);
    const keys = Object.keys(parsedEntityId);
    return keys.length ? keys[0].split(".")[0].replace("CDM_", "") : "";
};

function hasJsonStructure(str) {
    if (typeof str !== "string") return false;
    try {
        const result = JSON.parse(str);
        const type = Object.prototype.toString.call(result);
        return type === "[object Object]" || type === "[object Array]";
    } catch (err) {
        return false;
    }
}

const formatValueByType = (json, value, type, options, defaultValue, mask) => {
    let formatedValue = "";
    switch (type) {
        case "date":
            formatedValue = date(value, mask);
            break;
        case "currency":
            formatedValue = format(
                value,
                "normal",
                getValueFromJson(options, "currency"),
                getValueFromJson(options, "fractionDigits"),
                getValueFromJson(options, "locale"),
            );
            break;
        case "number":
            formatedValue = format(
                value,
                "normal",
                null,
                getValueFromJson(options, "fractionDigits"),
            );
            break;
        case "percentage":
            formatedValue = format(
                value,
                "normal",
                null,
                getValueFromJson(options, "fractionDigits"),
            );
            break;
        case "datetime":
            formatedValue = datetime(value, mask);
            break;
        case "object":
            const keyValue = (json[getValueFromJson(options, "id")] || {}).value;

            const objToReturn = keyValue
                ? {
                      id: (json[getValueFromJson(options, "id")] || {}).value,
                      name: (json[getValueFromJson(options, "name")] || {}).value,
                      __typename: getValueFromJson(options, "__typename"),
                  }
                : (json[getValueFromJson(options, "name")] || {}).value || defaultValue;

            return { type: keyValue ? type : "string", value: objToReturn };
        case "boolean":
            formatedValue = !!value === true ? I18n.translate(`Yes`) : I18n.translate(`No`);
            break;
        default:
            formatedValue = value || defaultValue;
            break;
    }

    return { type, value: formatedValue };
};

const mapCard = (json) => {
    const { TypeByField, EntityName, EntityID, DataFile, AuditStatusTotal, id, AuditStatus, F4 } =
        json;
    const entityType = (EntityName || "").split("::").pop();
    hideCheckBox = F4 !== "RelaxedSchemaValidationFinding";

    const result = Object.keys(TypeByField)
        .map((item) => {
            const tempItem = item.replace("T", "F");
            return [
                {
                    label: tempItem,
                    ...formatValueByType(
                        json,
                        json[tempItem],
                        TypeByField[item].type,
                        TypeByField[item].options,
                        TypeByField[item].defaultValue,
                        TypeByField[item].mask,
                    ),
                    align:
                        TypeByField[item] && TypeByField[item].align
                            ? TypeByField[item].align
                            : "left",
                    basis: TypeByField[item].basis,
                },
            ];
        })
        .filter((filter) => filter);

    const colbiDDField = snakeCaseToPascalCase(entityType, "CDM_", "s");
    const idToUse = hasJsonStructure(EntityID)
        ? EntityID
        : JSON.stringify({ [`${colbiDDField}.ID`]: EntityID });

    const entityToUse = hasJsonStructure(EntityID) ? extractEntityName(EntityID) : entityType;
    const linkObj = {
        labels: ["Refers Id"],
        value: {
            id: Buffer.from(idToUse).toString("base64"),
            name: I18n.translate`${entityType}`,
            __typename: `${entityToUse}`,
        },
        type: "object",
        align: "center",
    };

    if (EntityName === "File") {
        linkObj.value[`link`] = {
            to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/activity/status/?filter=${stringifyFilter(
                [{ column: "ID", filters: [{ value: `${json.ImportID}` }] }],
            )}`,
        };
    }
    result.push([linkObj]);
    result.push([{ labels: ["file"], value: DataFile, type: "string", align: "left" }]);
    if (hideCheckBox) {
        const auditStatusObj = {
            labels: "audit status",
            value: {
                id: id,
                name: I18n.translate`${AuditStatusTotal} Audit Note(s)`,
                pushModal: true,
            },
            type: "object",
            align: "center",
        };
        result.push(
            AuditStatusTotal !== 0
                ? [auditStatusObj]
                : [
                      {
                          labels: ["audit notes"],
                          value: I18n.translate`No Audit Notes`,
                          type: "string",
                          align: "center",
                      },
                  ],
        );
        result.push([
            {
                labels: ["audit status"],
                value: [AuditStatus.toLowerCase(), I18n.translate`${AuditStatus}`],
                type: "auditNoteStatus",
                align: "center",
            },
        ]);
        result.push([{ labels: ["Checkbox"], value: ["delete"], type: "user_actions" }]);
    }
    return result;
};

const header = (json) => {
    const headerMapping = Object.keys(json).map((elem) => {
        if (json[elem]) {
            const { name: label, align, basis } = json[elem];
            return { label: [label], align: align ? align : "left", basis };
        } else {
            return undefined;
        }
    });
    headerMapping.push({ label: ["reference"], align: "center" });
    headerMapping.push({ label: ["file"], align: "left" });
    if (hideCheckBox) {
        headerMapping.push({ label: ["audit notes"], align: "center" });
        headerMapping.push({ label: ["audit status"], align: "center" });
        headerMapping.push({ label: ["checkbox"], align: "right" });
    }
    return headerMapping;
};

const mapper = (json, card) => {
    return {
        ...json,
        __typename: json.__typename,
        card: card ? mapCard(json).filter((elem) => elem.length !== 0) : [],
    };
};

const ncfindingMapper = {
    map: mapper,
    header,
};

export default ncfindingMapper;
